import React from 'react';
import { ValidationIcon } from '../../../icons';
import { handlePhoneMaskOnInput } from '../../../../utils/payment/masks';

interface PhoneFieldProps {
  value: string;
  error?: string;
  isValid: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const PhoneField: React.FC<PhoneFieldProps> = ({
  value,
  error,
  isValid,
  onChange,
  onBlur,
}) => {
  const inputBaseClass = 'w-full p-3 border rounded-md shadow-sm text-sm focus:ring-primary focus:border-primary bg-input-bg-light dark:bg-input-bg-dark text-text-primary dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500';
  const errorBorderClass = 'border-red-500';
  const normalBorderClass = 'border-medium-gray dark:border-gray-600';

  return (
    <div className="relative">
      <label htmlFor="homephone" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
        Celular (com DDD) *
      </label>
      <div className="relative">
      <input
        type="tel"
        name="homephone"
        id="homephone"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder="(00) 00000-0000"
        minLength={10}
        maxLength={15}
        onInput={handlePhoneMaskOnInput}
        autoComplete="off"
        className={`${inputBaseClass} ${error ? errorBorderClass : normalBorderClass}`}
        aria-describedby={error ? 'phone-error' : undefined}
      />
      <ValidationIcon isValid={isValid} />
      {error && (
        <p id="phone-error" className="text-xs text-red-500 mt-1">
          {error}
        </p>
      )}
      </div>
    </div>
  );
};

export default PhoneField; 